<template>
  <div class="print-credentials">
    <div class="print-content" style="margin: 30px 0" id="printTest1">
      <div
        style="
          width: 100%;
          margin: 0;
          margin-bottom: 15px;
          display: flex;
          justify-content: space-between;
        "
      >
        <!-- Left: Logo + Company Info -->
        <div style="text-align: left">
          <div style="display: flex; align-items: center; margin-bottom: 15px">
            <el-image
              style="width: 45px; margin-right: 10px"
              :src="require('../assets/image/Logo/logo.png')"
            ></el-image>
            <h1 style="font-size: 26px; margin: 0">
              {{ "AFUWA MONEY" }}
            </h1>
          </div>
          <p style="margin: 4px 0; font-size: 12px">Niamey, Niger</p>
          <p style="margin: 4px 0; font-size: 12px">
            {{ $t("Customer Service") }}: 87040404
          </p>
          <p style="margin: 4px 0; font-size: 12px">www.bnif-afuwa.com</p>
        </div>

        <!-- Right: QR Code -->
        <div style="text-align: center; margin-top: 10px">
          <qr-code :param="downloadUrl" :size="80" />
          <p style="font-size: 10px; margin: 4px 0; color: #666">
            {{ $t("Download App") }}
          </p>
        </div>
      </div>
      <div style="padding: 15px 20px; text-align: center">
        <h1 style="font-size: 28px; font-weight: 400; margin: 0; color: #000">
          {{ $t("receiptDeposit") }}
        </h1>
      </div>
      <div v-for="(v, k) in printParam" :key="k" :style="p">
        <div :style="key">
          <div>{{ $t(k) }}</div>
        </div>
        <div :style="value" v-if="k == 'dealType'">
          <div style="line-height: 20px">{{ $t(v) }}</div>
        </div>
        <div :style="value" v-else>
          <div style="line-height: 20px">{{ $t(v) }}</div>
        </div>
      </div>
      <!-- signature -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          margin-top: 40px;
          padding: 0 10px;
        "
      >
        <div style="text-align: center; width: 45%">
          <p style="margin: 0 0 45px 0; font-size: 13px">
            {{ $t("customer") }}
          </p>
          <div style="border-top: 1px solid #000"></div>
        </div>

        <div style="text-align: center; width: 45%">
          <p style="margin: 0 0 45px 0; font-size: 13px">
            {{ loginInfo.name }} {{ loginInfo.surname }}
          </p>
          <div style="border-top: 1px solid #000"></div>
        </div>
      </div>

      <p style="text-align: right; margin-top: 25px; font-size: 12px">
        {{ $manba().format("ymdhms") }}
      </p>
    </div>
    <div class="print-btn">
      <el-button size="mini" @click="openCallback">{{ $t("close") }}</el-button>
      <el-button type="primary" size="mini" v-print="printConfig">{{
        $t("printrRceipt")
      }}</el-button>
    </div>
  </div>
</template>
<script>
// import country from '@/api/country'
import qrCode from "@/components/QRcode.vue";
import uploading from "@/api/uploading";
export default {
  components: { qrCode },
  name: "printCredentialsDeposit",
  props: ["param", "title", "isClosePrint"],
  data() {
    return {
      printConfig: {
        id: "printTest1",
        openCallback(vue) {
          vue.printLoading = false;
          vue.openCallback(vue);
        },
      },
      p: "border:1px solid #a7a7a7; overflow:hidden; padding:0 10px; margin:-1px 0 0;",
      key: "float:left; width: 300px; padding:5px 0; border-right: 1px solid #a7a7a7; font-weight: 600;",
      value:
        "float:left; width:calc(100% - 311px); padding:5px 0; border-left:1px solid #a7a7a7; margin-left:-1px; padding-left:10px;",
    };
  },
  computed: {
    downloadUrl() {
      return uploading.download();
    },
    printParam() {
      if (!this.param) return {};
      console.log(this.param);
      let printParam = {
        transactionCode:
          this.param.transactionCode || this.param.remittorTransactionCode,
        depositorFirstName:
          (this.param.depositorFirstName || "") +
          " " +
          (this.param.depositorLastName || ""),
        depositorPhoneNo: this.param.depositorPhoneNo || "",
        payeeName: (this.param.name || "") + " " + (this.param.surname || ""),
        payeePhone: this.param.phone || undefined,
        tradingHour: this.$manba(this.param.dateTime).format("ymdhms"),
        dealType: this.param.businessType,
        transactionAmount:
          (this.param.amount || 0).toLocaleString("fr-FR") + " FCFA",
        //"Transaction tax": (this.param.taxAmount || 0).toLocaleString("fr-FR") + " FCFA",
        "service charge":
          (this.param.purposeBefore || 0).toLocaleString("fr-FR") + " FCFA",
        purpose: this.param.purpose || "",
        //operator: this.param.createId,
        operateOrg: this.param.orgInfoName,
      };

      let plist = {};
      for (let k in printParam) {
        if (printParam[k]) plist[k] = printParam[k];
      }
      console.log(this.param);
      return plist;
    },

    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
  },
  methods: {
    //打印阅览框打开时回调
    openCallback() {
      this.$emit("update:isClosePrint", !this.isClosePrint);
    },
    /**调用父组件清空信息*/
    clearFatherNodeData() {
      this.$parent.clearData();
    },
  },
};
</script>

<style lang="less" scoped>
.print-credentials {
  margin: -50px 0 0;

  .print-btn {
    text-align: right;
    margin-top: 30px;
  }
}
</style>
